import { render } from "./DashboardArtritis.vue?vue&type=template&id=5db83893"
import script from "./DashboardArtritis.vue?vue&type=script&lang=js"
export * from "./DashboardArtritis.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__